import '../../App.css'
import { useEffect, useState } from 'react'
import axios from 'axios'
import Aside from '../../component/aside'
import { useNavigate, useParams } from 'react-router-dom'
import Navbar from '../../component/navbar'
import Loading from '../../component/loading'

function SectionEdit() {
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        if (!JSON.parse(localStorage.getItem('authResult'))) {
            navigate('/login')
        }
    }, [])
    const [dataGet, setDataGet] = useState([])
    const [addData, setAddData] = useState({})
    const [oldData, setOldData] = useState({})
    let user = JSON.parse(localStorage.getItem('authResult'))
        ? JSON.parse(localStorage.getItem('authResult'))
        : { role: '' }
    const { id } = useParams()
    let navigate = useNavigate()

    useEffect(() => {
        if (user.role !== 'human_resource' && user.role !== 'management') {
            localStorage.removeItem('authResult')
            navigate('/login')
        }
    }, [])

    const setQueryPropertyAddData = (key, e) => {
        switch (key) {
            case 'name':
                setAddData({ ...addData, name: e.target.value })
                break
            case 'userId':
                setAddData({
                    ...addData,
                    userId: {
                        id: e.target.value,
                    },
                })
                break

            default:
                return null
        }
    }

    console.log(addData)

    useEffect(() => {
        setLoading(true)
        getUsers()
        getSection()
    }, [])

    const getSection = () => {
        axios
            .get(`http://188.121.105.111:3000/sections/${id}`)
            .then((res) => {
                setAddData(res.data)
                setOldData(res.data)
                setLoading(false)
            })
            .catch((error) => {
                setLoading(false)
            })
    }
    const getUsers = () => {
        axios
            .get(`http://188.121.105.111:3000/user`)
            .then((res) => {
                setDataGet(res.data)
                setLoading(false)
            })
            .catch((error) => {
                setLoading(false)
            })
    }

    const handlerSubmit = () => {
        setLoading(true)
        let updateData = {
            name: addData.name,
            userId: addData.userId.id,
        }

        axios
            .post(`http://188.121.105.111:3000/sections/`, addData)
            .then((res) => {
                axios
                    .patch(
                        `http://188.121.105.111:3000/user/${addData.userId.id}`,
                        {
                            role: 'section',
                            supervisor: true,
                            roleChildId: null,
                        }
                    )
                    .then((res) => {
                        if (addData.userId.id !== oldData.userId.id) {
                            axios
                                .patch(
                                    `http://188.121.105.111:3000/user/${oldData.userId.id}`,
                                    {
                                        role: 'personnel',
                                        supervisor: false,
                                        roleChildId: null,
                                    }
                                )
                                .then((res) => {
                                    setLoading(false)
                                    navigate('/sections')
                                })
                                .catch((error) => {
                                    setLoading(false)
                                })
                        } else {
                            navigate('/sections')
                            setLoading(false)
                        }
                    })
                    .catch((error) => {
                        setLoading(false)
                    })
            })
            .catch((error) => {
                setLoading(false)
            })
    }
    const handlerCancel = () => {
        navigate(-1)
    }

    return (
        <>
            {loading ? <Loading /> : null}
            <div className="container">
                <Aside />
                <main className="main-content">
                    <Navbar />
                    <div className="box transaction-box">
                        <div className="header-container">
                            <h3 className="section-header">افزودن بخش</h3>
                        </div>

                        <div className="flex flex-col w-25 m-2">
                            <lablel>نام بخش:</lablel>
                            <input
                                className="input m-1"
                                type="text"
                                onChange={(e) => {
                                    setQueryPropertyAddData('name', e)
                                }}
                                value={addData.name}
                            />
                        </div>

                        <div className="flex flex-col w-25 m-2">
                            <label>سرپرست بخش</label>
                            <select
                                id="substitutePersonId"
                                className="input"
                                style={{ width: '200px' }}
                                name="substitutePersonId"
                                onChange={(e) => {
                                    setQueryPropertyAddData('userId', e)
                                }}
                            >
                                <option value="none" selected>
                                    انتخاب کنید
                                </option>
                                {dataGet.map((d) => {
                                    return addData.userId !== undefined &&
                                        addData.userId.id === d.id ? (
                                        <option value={d.id} selected>
                                            {d.fullName}
                                        </option>
                                    ) : (
                                        <option value={d.id}>
                                            {d.fullName}
                                        </option>
                                    )
                                })}
                            </select>
                        </div>

                        <div className="flex w-full">
                            <button
                                className="btn main-clr-bg w-50 m-2 white-clr font-bold"
                                onClick={handlerSubmit}
                            >
                                ثبت
                            </button>
                            <button
                                className="btn red-clr-bg w-50 m-2 white-clr font-bold"
                                onClick={handlerCancel}
                            >
                                لغو
                            </button>
                        </div>
                    </div>
                </main>
            </div>
        </>
    )
}

export default SectionEdit
